import {
  DirtyRepliersListingCondoExposure,
  UnsanitizedRepliersListingCondoExposure,
} from '../../types/repliers/UnsanitizedRepliersListingCondoExposure';
import { RepliersListingCondoExposure } from '../../types/repliers/RepliersListingCondoExposure';

export default function sanitizeRepliersCondoExposure(
  condoExposure: UnsanitizedRepliersListingCondoExposure | '' | null,
): RepliersListingCondoExposure | null {
  if (!condoExposure) {
    return null;
  }

  switch (condoExposure) {
    case DirtyRepliersListingCondoExposure.NorthITSO:
      return RepliersListingCondoExposure.N;
    case DirtyRepliersListingCondoExposure.SouthITSO:
      return RepliersListingCondoExposure.S;
    case DirtyRepliersListingCondoExposure.EastITSO:
      return RepliersListingCondoExposure.E;
    case DirtyRepliersListingCondoExposure.WestITSO:
      return RepliersListingCondoExposure.W;
  }

  return condoExposure;
}
